import FromClient from 'clients/mail_from_client'
import FormGroup from 'components/form_group'
import Toast from 'components/toast'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Modal from 'react-overlays/lib/Modal'
import { setModalStyle } from 'supports/modal_style_helper'

export default class FromCreateModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: null,
      error: null,
      name: null,
      sending: false
    }
  }

  handleChangeName(name) {
    this.setState({
      name
    })
  }

  handleChangeEmail(email) {
    this.setState({
      email
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    const { onCreate } = this.props
    const { name, email } = this.state

    if (name === null || email === null) {
      return
    }

    this.setState({
      sending: true
    })

    const formData = new FormData(e.target)
    FromClient.createFrom(formData)
      .then(from => {
        Toast.notify(I18n.t('components.mail_from.from_create_modal.message.save.complete'))
        this.setState({
          email: null,
          error: null,
          name: null,
          sending: false
        })
        onCreate(from)
      })
      .catch(error => {
        Toast.notify(I18n.t('components.mail_from.from_create_modal.message.save.failure'))
        this.setState(
          {
            error,
            sending: false
          },
          () => setModalStyle(this.modal)
        )
      })
  }

  handleCancel() {
    const { onCancel } = this.props

    this.setState({
      email: null,
      error: null,
      name: null,
      sending: false
    })
    onCancel()
  }

  render() {
    const { show } = this.props
    const { email, error, name, sending } = this.state
    const hasName = name !== null && name.length > 0
    const hasEmail = email !== null && email.length > 0
    const inputName = 'name'
    const inputEmail = 'email'

    return (
      <Modal show={show} onShow={() => setModalStyle(this.modal)}>
        <div className="modal modal-mail-from">
          <div className="modal-bg" role="presentation" onClick={() => this.handleCancel()} />
          <div
            className="modal-in"
            ref={ref => {
              this.modal = ref
            }}
          >
            <div className="modal-header">
              <div className="title">{I18n.t('components.mail_from.from_create_modal.title')}</div>
              <button type="button" className="btn btn-close" onClick={() => this.handleCancel()}>
                <i className="ic-close" />
              </button>
            </div>
            <div className="modal-content">
              <form onSubmit={e => this.handleSubmit(e)}>
                <div className="modal-form">
                  <FormGroup error={error} name={inputName}>
                    <input
                      type="text"
                      name={`mail_from[${inputName}]`}
                      className="form-control"
                      placeholder={I18n.t('components.mail_from.from_create_modal.name.placeholder')}
                      defaultValue=""
                      onChange={e => this.handleChangeName(e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup error={error} name={inputEmail}>
                    <input
                      type="email"
                      name={`mail_from[${inputEmail}]`}
                      className="form-control"
                      placeholder={I18n.t('components.mail_from.from_create_modal.mail.placeholder')}
                      defaultValue=""
                      onChange={e => this.handleChangeEmail(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="modal-submit">
                  <input
                    type="submit"
                    className="btn btn-submit"
                    value={
                      sending
                        ? I18n.t('components.mail_from.from_create_modal.button.sending')
                        : I18n.t('components.mail_from.from_create_modal.button.register')
                    }
                    disabled={sending || !hasName || !hasEmail}
                  />
                  <button type="button" className="btn btn-default" onClick={() => this.handleCancel()}>
                    {I18n.t('common.button.cancel')}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

FromCreateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired
}
